import PropTypes from "prop-types"
import { Card } from 'nachos-ui';
import React from 'react';
import {
  TouchableOpacity,
  Modal,
  View,
  Text,
  Image,
  Platform,
  Dimensions,
  FlatList,
} from 'react-native';
import styles from '../InternalComponents/styles/style';
import Autocomplete from '../../components/customAutoComplete';
import { getResponsiveStyle, widthInPercentage } from '../../utils/appUtils';
// import Modal from 'react-native-modal';
import { ALL_CONSTANTS } from '../../constants/displayConstants';
import Hoverable from '../../components/hover/hoverable';
import CustomBootbox from '../../components/CustomBootbox';
import {
  AUTH,
  getGoogleLocation,
} from '../../network/request/apirequests.js';
import ApiTag from '../../network/request/apiTags';
import style from '../OverDue/newStyle';

const isNull = (value) => !value || value === undefined || value === '';

const x_stu_O = 'AIzaSyCcFtl0ekH3uaG2eF6YklOoPPPR2LWr-6o';
const formatData = (data, numColumns) => {
  const numberOfFullRows = Math.floor(data.length / numColumns);

  let numberOfElementsLastRow = data.length - numberOfFullRows * numColumns;
  while (
    numberOfElementsLastRow !== numColumns &&
    numberOfElementsLastRow !== 0
  ) {
    data.push({ key: `blank-${numberOfElementsLastRow}`, empty: true });
    numberOfElementsLastRow++;
  }

  return data;
};
export default class Topsection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowHeight: Dimensions.get('window').height,
      valueSelected: '',
      userIp: '',
      longitude: '',
      latitude: '',
      dropdownOpen: false,
      hidemenu: false,
      searchFlag: true,
      userAddress: '',
    };
    this.makeAPICall = props.makeAPICall;
  }
  componentDidMount() {
    // * fetch location and ip from session
    let location = sessionStorage.getItem('location');
    let userIp = sessionStorage.getItem('userIp');
    let longitude = sessionStorage.getItem('longitude');
    let latitude = sessionStorage.getItem('latitude');

    const isVerificationURL = window.location.href.includes("due/overdueScreen");

    if (
      isNull(location) &&
      isNull(userIp) &&
      isNull(longitude) &&
      isNull(latitude) &&
      !isVerificationURL
    ) {
      this.fetchIpLocation(); // * only fetch IP Location on component mount
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.getCoordinates,
          this.handleLocationError
        );
      }
    } else {
      this.setState({
        bootboxtext: ALL_CONSTANTS.ENABLE_LOCATION,
        headerText: '',
        Blackout: true,
        latitude,
        longitude,
        userIp,
        userAddress: location,
      });
    }
  }

  componentWillReceiveProps(newprops) {
    if (Platform.OS === 'web') {
      const pathName = window.location.pathname;
      switch (true) {
        case pathName.includes(ALL_CONSTANTS.PROFILE_PATH):
          id = 1;
          this.setState({
            hidemenu: true,
          });
          break;
        case pathName.includes(ALL_CONSTANTS.ACCOUNT_PATH):
          id = 2;
          this.setState({ hidemenu: true });
          break;
        case pathName.includes(ALL_CONSTANTS.CREDIT_CARD_PATH):
          id = 3;
          this.setState({
            hidemenu: true,
          });
          break;
        case pathName.includes(ALL_CONSTANTS.LOAN_PATH):
          id = 4;
          this.setState({ hidemenu: true });
          break;
        case pathName.includes(ALL_CONSTANTS.DEPOSITS_PATH):
          id = 5;
          this.setState({ hidemenu: true });
          break;
        case pathName.includes(ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH):
          id = 7;
          this.setState({
            hidemenu: true,
          });
          break;
        case pathName.includes(ALL_CONSTANTS.FOREX_PATH):
          id = 8;
          this.setState({ hidemenu: true });
          break;
        default:
          null;
      }
      // this.fetchIpLocation();
      // if (navigator.geolocation) {
      //   //allow location to check your location
      //   navigator.geolocation.getCurrentPosition(
      //     this.getCoordinates,
      //     this.handleLocationError
      //   );
      // }
      // else {
      //     this.setState({
      //         bootboxmodal: true,
      //         bootboxtext: "We're sorry, please enable location to move ahead",
      //         Blackout: true,
      //     });
      // }
    }
  }

  refresh() {
    var clear = [
      'time',
      'product_name',
      'payment_gateway',
      'stopwatch',
      'credit_opted',
      'flow',
      'easyPay',
      'token',
    ];

    clear.map((item) => {
      sessionStorage.removeItem(item);
    });
  }

  closebootbox = () => {
    if (this.state.userIdle) {
      this.refresh();
      window.removeEventListener('keydown', this.handleKeyPress);
      if (Platform.OS == 'web') {
        const pathName = window.location.pathname;
        const domainName = window.location.origin;

        const path = [
          ALL_CONSTANTS.PROFILE_PATH,
          ALL_CONSTANTS.ACCOUNT_PATH,
          ALL_CONSTANTS.CREDIT_CARD_PATH,
          ALL_CONSTANTS.LOAN_PATH,
          ALL_CONSTANTS.DEPOSITS_PATH,
          ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
          ALL_CONSTANTS.FOREX_PATH,
          ALL_CONSTANTS.DUE_PATH,
        ];

        let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
        if (path.includes(updatedPath)) {
          window.location.href = `${domainName}${updatedPath}`;
          return;
        } else {
          window.location.href = `${domainName}/servicing/index.html`;
        }
      } else {
        window.location.href = `${domainName}/servicing/index.html`;
        //props.navigation.navigate('HomePage');
      }
      // Linking.openURL(window.location.origin);
    } else {
      this.setState({
        openmodel: false,
        modalopenhide: false,
      });
    }
  };

  handleLocationError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        this.setState({
          userIdle: true,
          bootboxtext:
            '\n\nLooks like your location permission is blocked for entered website. Please provide location access to proceed further. Here’s how you can navigate:\n\nIf you are using laptop/ desktop:\n\nChrome Settings / More Settings by clicking on right top browser settings menu >> Privacy & Security >> Site Settings >> Permissions >> Location >> Select Enable/ Allow for https://service.icicibank.com\n\nIf you are using mobile device:\n\nSettings >> Site Settings/ App Settings >> Permissions >> Location >> Chrome >> Enable/ allow for https://service.icicibank.com',
          headerText: 'Your Location access is blocked',
          openmodel: true,
        });
        console.log('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        console.log('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        console.log('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        console.log('An unknown error occurred.');
        break;
    }
  };
  getCoordinates = (position) => {
    this.setState({
      longitude: position.coords.longitude,
      latitude: position.coords.latitude,
    });
    sessionStorage.setItem('longitude', position.coords.longitude);
    sessionStorage.setItem('latitude', position.coords.latitude);
    this.reverseGeoCode();
  };

  reverseGeoCode = () => {
    let longitude = sessionStorage.getItem('longitude');
    let latitude = sessionStorage.getItem('latitude');
    let fieldData = {
      geoLat: latitude,
      geoLong: longitude,
      // "geoLat": "15.6835224",
      //   "geoLong": "74.6680036",
    };

    this.makeAPICall(
      getGoogleLocation(fieldData, AUTH),
      this.onDataReceived,
      this.onError
    );
    // fetch(
    //   `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.state.latitude},${this.state.longitude}&sensor=true&key=${x_stu_O}`
    // )
    //   .then(response => response.json())
    //   .then(data =>
    //     this.setState({
    //       userAddress: data.plus_code.compound_code.substring(8)
    //     })
    //   )
    //   .catch(error => error);
  };
  onDataReceived = async (response) => {
    this.setState({ loading: false });

    if (ApiTag.DEACTIVATE_TOKEN == response.tag) {
      if (response.data.status === 200) {
        if (Platform.OS === 'web') {
          sessionStorage.removeItem('token');
        } else {
          await AsyncStorage.removeItem('token');
        }
      }
    } else if (ApiTag.GETSERVICE == response.tag) {
      let array = [];
      let ServiceImages = null;
      for (let i = 0; i < response.data.data.length; i += 1) {
        if (response.data.data[i]['images'] === null) {
          ServiceImages = require('../../assets/images/icon_email.png');
        } else {
          ServiceImages = response.data.data[i]['images'];
        }
        let dataArray = [];
        Object.keys(response.data.data[i]).forEach((key, val, item) => {
          dataArray = {
            id: response.data.data[i]['servicename'],
            serviceId: response.data.data[i]['serviceId'],
            servicename: response.data.data[i]['servicename'],
            title: response.data.data[i]['servicename'],
            serviceType: response.data.data[i]['serviceType'],
            images: ServiceImages,
            dynamicStatus: response.data.data[i]['dynamicStatus'],
            menuname: response.data.data[i]['menuname'],
            dynamicMessage: response.data.data[i]['message'],
            dynamicMenuType: response.data.data[i]['menuType'],
            keywordSearch: response.data.data[i]['keywordSearch'],
            displayName: response.data.data[i]['displayMessage'],
          };
        });
        array.push(dataArray);
      }
      this.setState({
        searchArray: array,
      });
    } else if (ApiTag.GETGOOGLELOC == response.tag) {
      this.setState({
        userAddress: response.data.data.address,
      });
      sessionStorage.setItem('location', response.data.data.address);
    }
  };
  onError = (err) => {
    if (ApiTag.GETSERVICE == err.tag) {
    } else if (ApiTag.Menu_Option == err.tag) {
    } else if (ApiTag.GETGOOGLELOC == err.tag) {
    }
  };

  fetchIpLocation() {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          userIp: data.ip,
        });
        sessionStorage.setItem('userIp', data.ip);
      })
      .catch((error) => this.setState({ userIp: 0 }));
  }

  onSubmit = async () => {
    this.setState({ searchFlag: true });
  };
  gotOService = async (data) => {
    this.props.navigation.state.params = {};
    this.props.navigation.state.params.flow = data.servicename;
    this.props.navigation.state.params.serviceType = data.serviceType;
    this.props.navigation.state.params.servicename = data.servicename;
    this.props.navigation.state.params.serviceDynamic = data.dynamicStatus;
    this.props.navigation.state.params.menuType = data.menuType;
    this.props.navigation.state.params.menuname = data.menuType;
    this.props.navigation.state.params.serviceMessageForNoDynamic =
      data.message;

    this.props.navigation.state.params.flag = true;

    if (Platform.OS === 'web') {
      sessionStorage.setItem('flag', 'true');
    } else {
      await AsyncStorage.setItem('flag', 'true');
    }
    this.props.navigation.navigate(
      'Verification',
      this.props.navigation.state.params
    );
  };

  toggle = () => {
    if (this.props.TopnavMobcallback) {
      this.props.TopnavMobcallback(this.state.dropdownOpen);
    }
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  OnServiceRequestsButtonPress(
    servicename,
    menuType,
    index,
    menuHeader,
    menuname
  ) {
    this.props.OnServiceRequestsButtonPress(
      servicename,
      menuType,
      index,
      menuHeader,
      menuname
    );
  }
  // Overdue Logout
  logout = () => {
    this.props.navigation.navigate(
      'Verification',
      this.props.navigation.state.params
    );
  };

  renderItem = ({ item, index, props }) => {
    const { measure, overdueFlag } = this.props;
    if (item.empty === true) {
      return (
        <View
          style={[
            styles.serviceBoxPadding,
            {
              flex: 1,
              justifyContent: !this.state.machine ? 'space-around' : null,
            },
            styles[getResponsiveStyle('serviceBoxPadding', measure)],
          ]}
        >
          <TouchableOpacity
            onClick={() => {
              props.OnServiceRequestsButtonPress(
                item.servicename,
                item.menuType,
                index,
                item.menuHeader,
                item.menuname
              );
            }}
          >
            <Text
              style={[
                styles.serviceText,
                styles[getResponsiveStyle('serviceText', measure)],
              ]}
            >
              {item.Title}
            </Text>
          </TouchableOpacity>
        </View>
      );
    } else if (overdueFlag) {
      return (
        <View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <View
              style={[
                style.menuNameView,
                {
                  backgroundColor:
                    this.props.selectedIndex === index ? '#fcf2eb' : 'white',
                },
              ]}
            >
              <TouchableOpacity
                onPress={() => {
                  this.props.OnServiceRequestsButtonPress(
                    item.menuname,
                    item.menuType,
                    index,
                    item.menuHeader,
                    item.menuname
                  );
                }}
              >
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <View>
                    <Image
                      style={[style.verificationImage]}
                      source={require(`../OverDue/components/icons/menuIcons/${item.menuType}.svg`)}
                    ></Image>
                  </View>
                  <View
                    style={{
                      marginLeft: 10,
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Text
                      style={[
                        style.menuName,
                        {
                          fontFamily: "'Mulish'",
                          fontStyle: 'normal',
                          fontWeight: 400,
                          fontSize: '20px',
                          lineHeight: '12px',
                          color:
                            this.props.selectedIndex === index
                              ? '#f7ac6d'
                              : '#787F89',
                        },
                      ]}
                    >
                      {item.menuname}
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      );
    }
    return (
      <View
        style={[
          styles.serviceMenuBoxPadding,
          { flex: 1 },
          styles[getResponsiveStyle('serviceMenuBoxPadding', measure)],
        ]}
      >
        <TouchableOpacity
          onPress={() => {
            this.OnServiceRequestsButtonPress(
              item.servicename,
              item.menuType,
              index,
              item.menuHeader,
              item.menuname
            );
          }}
          style={
            measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI'
              ? [
                  {
                    height: '100%',
                    borderRadius: 2,
                    elevation: Platform.OS === 'web' ? 5 : 2,
                    //padding: '1%',
                    justifyContent: 'center',
                    //alignItems: 'center',
                    shadowColor: 'grey',
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    paddingBottom: 0,
                    paddingRight: 0,
                    shadowOpacity: 0.2,
                    shadowRadius: 15,
                    backgroundColor: item.serviceSelected ? '#ef6912' : 'white',
                  },
                ]
              : [
                  styles.serviceBox,
                  styles[getResponsiveStyle('serviceBox', measure)],
                ]
          }
        >
          <View
            style={
              measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI'
                ? [
                    styles.serviceImageView,
                    styles[getResponsiveStyle('serviceImageView', measure)],
                  ]
                : [
                    styles.serviceImageView,
                    styles[getResponsiveStyle('serviceImageView', measure)],
                  ]
            }
          >
            {`${item.images}`.includes('http') ? (
              <Image
                style={[
                  styles.serviceImageStyle,
                  styles[getResponsiveStyle('serviceImageStyle', measure)],
                ]}
                source={item.image_icons}
              />
            ) : (
              <Image
                style={[
                  styles.serviceImageStyle,
                  styles[getResponsiveStyle('serviceImageStyle', measure)],
                ]}
                source={{ uri: item.image_icons }}
              />
            )}
          </View>
          <Hoverable>
            {(isHovered) => (
              <View
                style={[
                  styles.serviceTextView,
                  styles[getResponsiveStyle('serviceTextView', measure)],
                ]}
              >
                {isHovered ? (
                  <Text
                    style={[
                      styles.serviceMenuText,
                      { color: item.serviceSelected ? 'white' : '#222222' },
                      styles[getResponsiveStyle('serviceMenuText', measure)],
                    ]}
                  >
                    {overdueFlag ? item.menuname : item.servicename}
                  </Text>
                ) : (
                  <Text
                    style={[
                      styles.serviceMenuText,
                      { color: item.serviceSelected ? 'white' : '#222222' },
                      styles[getResponsiveStyle('serviceMenuText', measure)],
                    ]}
                  >
                    {item.servicename}
                  </Text>
                )}
                {/* <Text style={[
                  styles.serviceMenuDescText,
                  { color: item.serviceSelected ? 'white' : '#222222', marginTop: widthInPercentage(2) },
                  styles[getResponsiveStyle('serviceMenuDescText', measure)]
                ]}>{item.text}</Text> */}
              </View>
            )}
          </Hoverable>
          <View
            style={{ alignItems: 'flex-end', marginTop: widthInPercentage(2) }}
          >
            <View
              style={[
                styles.menuView,
                { backgroundColor: item.color },
                styles[getResponsiveStyle('menuView', measure)],
              ]}
            >
              <Image
                style={[
                  styles.serviceMenuImageArrowStyle,
                  { padding: 2 },
                  styles[
                    getResponsiveStyle('serviceMenuImageArrowStyle', measure)
                  ],
                ]}
                source={require('../../assets/images/menunewArrow.png')}
              />
            </View>
          </View>
        </TouchableOpacity>
      </View>
    );
  };
  render() {
    let props = this.props;
    const { measure, headerFlag, showip } = props;
    let homeScreen =
      this.props.homeScreen !== undefined ? this.props.homeScreen : false;
    let verification =
      this.props.verification !== undefined ? this.props.verification : false;
    let Dontshow_Searchoption =
      this.props.Dontshow_Searchoption !== undefined
        ? this.props.Dontshow_Searchoption
        : false;
    return (
      <View>
        <View
          style={[
            styles.TopnavMainview,
            {
              zIndex: 7,
              height:
                verification || homeScreen
                  ? this.state.dropdownOpen
                    ? 120
                    : 60
                  : 60,
            },
            styles[getResponsiveStyle('TopnavMainview', measure)],
          ]}
        >
          <CustomBootbox
            {...this.props}
            measure={measure}
            bootboxtext={this.state.bootboxtext}
            headerText={this.state.headerText}
            bootboxmodal={this.state.openmodel}
            closebootbox={this.closebootbox}
            hideBlackout
          />
          <View
            style={[
              styles.TopnavMainview2,
              {
                flexDirection: verification || homeScreen ? 'column' : 'row',
                alignItems:
                  verification || homeScreen ? 'flex-start' : 'center',
              },
              styles[getResponsiveStyle('TopnavMainview2', measure)],
            ]}
          >
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: verification || homeScreen ? '100%' : 'null',
              }}
            >
              {homeScreen ? (
                <View
                  style={[
                    styles.TopnavMainview3topnavmob,
                    styles[
                      getResponsiveStyle('TopnavMainview3topnavmob', measure)
                    ],
                  ]}
                >
                  {headerFlag && this.state.hidemenu != true ? (
                    <TouchableOpacity
                      style={{ marginTop: widthInPercentage(4) }}
                      onPress={() => {
                        props.RendermenuBar(!props.openMobilelist);
                      }}
                    >
                      <Image
                        style={[
                          styles.TopnavMobileMenuicon,
                          styles[
                            getResponsiveStyle('TopnavMobileMenuicon', measure)
                          ],
                        ]}
                        resizeMode="contain"
                        source={require('../../assets/images/menu.png')}
                      />
                    </TouchableOpacity>
                  ) : measure === 'LDPI' ||
                    measure === 'MDPI' ||
                    measure === 'HDPI' ? (
                    <View style={{ flexDirection: 'row' }}>
                      <View
                        style={[
                          styles.TopNavDropdownMainView,
                          { flexDirection: 'row' },
                          styles[
                            getResponsiveStyle(
                              'TopNavDropdownMainView',
                              measure
                            )
                          ],
                        ]}
                      >
                        <TouchableOpacity onPress={() => this.toggle()}>
                          <Image
                            style={[
                              styles.TopNavDropdownImgViewhomescreen,
                              styles[
                                getResponsiveStyle(
                                  'TopNavDropdownImgViewhomescreen',
                                  measure
                                )
                              ],
                            ]}
                            source={require('../../assets/images/dropdownVerification.png')}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                  ) : (
                    <View
                      style={[
                        styles.TopnavMobileIPLOCATIONdettopnavmob,
                        styles[
                          getResponsiveStyle(
                            'TopnavMobileIPLOCATIONdettopnavmob',
                            measure
                          )
                        ],
                      ]}
                    >
                      <View>
                        <Text
                          style={[
                            styles.TopnavMobileIPText,
                            styles[
                              getResponsiveStyle('TopnavMobileIPText', measure)
                            ],
                          ]}
                        >
                          IP: {this.state.userIp}
                        </Text>
                      </View>
                      <View style={{ marginTop: 5 }}>
                        <Text
                          style={[
                            styles.TopnavMobileIPText,
                            styles[
                              getResponsiveStyle('TopnavMobileIPText', measure)
                            ],
                          ]}
                        >
                          Location: {this.state.userAddress}
                        </Text>
                      </View>
                    </View>
                  )}
                </View>
              ) : null}
              {Dontshow_Searchoption ? null : (
                <View
                  style={[
                    styles.TopsectionMainViewtopnavmob,
                    styles[
                      getResponsiveStyle('TopsectionMainViewtopnavmob', measure)
                    ],
                  ]}
                >
                  {measure === 'LDPI' ||
                  measure === 'MDPI' ||
                  measure === 'HDPI' ||
                  measure === 'XHDPI' ? (
                    <View
                      style={[
                        styles.TopsectionAutocompleteView,
                        styles[
                          getResponsiveStyle(
                            'TopsectionAutocompleteView',
                            measure
                          )
                        ],
                      ]}
                    >
                      <View
                        style={[
                          styles.TopsectionAutocompleteView2,
                          styles[
                            getResponsiveStyle(
                              'TopsectionAutocompleteView2',
                              measure
                            )
                          ],
                        ]}
                      >
                        {this.state.searchFlag === false ? (
                          <View style={{ width: '100%', flexDirection: 'row' }}>
                            <View style={{ flex: 2 }}>
                              <Slider {...settings}>
                                <View
                                  style={{
                                    flexDirection: 'row',
                                    backgroundColor: 'red',
                                    width: '100%',
                                  }}
                                >
                                  <View style={{ flex: 1 }}>
                                    {/* <Image
                              style={{
                                width: 10,
                                height: 10
                              }}
                              resizeMode='contain'
                              source={require('../../assets/images/searchicon.png')}
                            /> */}
                                  </View>
                                  <View style={{ flex: 2 }}>
                                    <TouchableOpacity
                                      onPress={() => this.gotOService(Data[0])}
                                    >
                                      <Text>{Data[0].servicename}</Text>
                                    </TouchableOpacity>
                                  </View>
                                </View>
                                <View>
                                  <TouchableOpacity
                                    onPress={() => this.gotOService(Data[1])}
                                  >
                                    <Text>{Data[1].servicename}</Text>
                                  </TouchableOpacity>
                                </View>
                                <View>
                                  <TouchableOpacity
                                    onPress={() => this.gotOService(Data[2])}
                                  >
                                    <Text>{Data[2].servicename}</Text>
                                  </TouchableOpacity>
                                </View>
                                <View>
                                  <TouchableOpacity
                                    onPress={() => this.gotOService(Data[3])}
                                  >
                                    <Text>{Data[3].servicename}</Text>
                                  </TouchableOpacity>
                                </View>
                                <View>
                                  <TouchableOpacity
                                    onPress={() => this.gotOService(Data[4])}
                                  >
                                    <Text>{Data[4].servicename}</Text>
                                  </TouchableOpacity>
                                </View>
                              </Slider>
                            </View>
                            <View
                              style={{
                                paddingHorizontal: '5%',
                                zIndex: -9,
                                width: '10%',
                                marginTop: '1%',
                              }}
                            >
                              <TouchableOpacity onPress={() => this.onSubmit()}>
                                <Image
                                  style={{
                                    width: 20,
                                    height: 20,
                                  }}
                                  resizeMode="contain"
                                  source={require('../../assets/images/searchicon.png')}
                                />
                              </TouchableOpacity>
                            </View>
                          </View>
                        ) : (
                          <View
                            style={[
                              styles.TopsectionAutocompleteView3,
                              styles[
                                getResponsiveStyle(
                                  'TopsectionAutocompleteView3',
                                  measure
                                )
                              ],
                            ]}
                          >
                            <Autocomplete
                              measure={measure}
                              autoCapitalize="none"
                              autoCorrect={false}
                              searchIcon={true}
                              hideResults={props.CloseSelectionDropdown}
                              inputContainerStyle={{
                                borderBottomWidth: null,
                                borderBottomColor: 'transparent',
                              }}
                              style={[
                                styles.TopsectionAutocompletestyle,
                                styles[
                                  getResponsiveStyle(
                                    'TopsectionAutocompletestyle',
                                    measure
                                  )
                                ],
                              ]}
                              data={props.SearchElements}
                              value={props.SelectedDropdownOption}
                              onChangeText={(text) => {
                                props.searchOptionChange(text);
                              }}
                              placeholder={'How can we help you?'}
                              renderItem={(val) => (
                                <TouchableOpacity
                                  style={[
                                    styles.TopsectionAutocompleteButtonstyle,
                                    styles[
                                      getResponsiveStyle(
                                        'TopsectionAutocompleteButtonstyle',
                                        measure
                                      )
                                    ],
                                  ]}
                                  onPress={() => {
                                    props.textInputChange(
                                      val.optionname.toUpperCase(),
                                      val
                                    );
                                  }}
                                >
                                  <Text
                                    style={[
                                      styles.TopsectionAutocompletemenutextstyle,

                                      styles[
                                        getResponsiveStyle(
                                          'TopsectionAutocompletemenutextstyle',
                                          measure
                                        )
                                      ],
                                    ]}
                                  >
                                    {val.dynamicMenuType.toUpperCase()}
                                  </Text>
                                  <Text
                                    style={[
                                      styles.TopsectionAutocompleteButtontextstyle,
                                      styles[
                                        getResponsiveStyle(
                                          'TopsectionAutocompleteButtontextstyle',
                                          measure
                                        )
                                      ],
                                    ]}
                                  >
                                    {val.optionname.toUpperCase()}
                                  </Text>
                                </TouchableOpacity>
                              )}
                            />
                          </View>
                        )}
                      </View>
                    </View>
                  ) : null}
                </View>
              )}
              {homeScreen ? (
                <View
                  style={[
                    styles.TopnavMobileLogoView,
                    styles[getResponsiveStyle('TopnavMobileLogoView', measure)],
                  ]}
                >
                  <TouchableOpacity>
                    <Image
                      style={[
                        styles.TopnavMobileLogostyle,
                        styles[
                          getResponsiveStyle('TopnavMobileLogostyle', measure)
                        ],
                      ]}
                      resizeMode="contain"
                      source={require('../../assets/images/icici-bank-logo.svg')}
                    />
                  </TouchableOpacity>
                </View>
              ) : null}
            </View>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: verification ? '100%' : 'null',
              }}
            >
              {verification ? (
                <View
                  style={[
                    styles.TopNavImage1MainView,
                    { flexDirection: 'row' },
                    styles[getResponsiveStyle('TopNavImage1MainView', measure)],
                  ]}
                >
                  <TouchableOpacity>
                    <Image
                      style={[
                        styles.TopNavImage1StyleView,
                        styles[
                          getResponsiveStyle('TopNavImage1StyleView', measure)
                        ],
                      ]}
                      source={require('../../assets/images/icici-bank-logo.svg')}
                    />
                  </TouchableOpacity>
                </View>
              ) : null}
              {verification ? (
                measure === 'LDPI' ||
                measure === 'MDPI' ||
                measure === 'HDPI' ? (
                  <View style={{ flexDirection: 'row' }}>
                    <View
                      style={[
                        styles.TopNavDropdownMainView,
                        { flexDirection: 'row' },
                        styles[
                          getResponsiveStyle('TopNavDropdownMainView', measure)
                        ],
                      ]}
                    >
                      <TouchableOpacity onPress={() => this.toggle()}>
                        <Image
                          style={[
                            styles.TopNavDropdownImgView,
                            styles[
                              getResponsiveStyle(
                                'TopNavDropdownImgView',
                                measure
                              )
                            ],
                          ]}
                          source={require('../../assets/images/dropdownVerification.png')}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                ) : (
                  <View
                    style={[
                      styles.TopnavMobileIPLOCATIONdettopnavmob,
                      styles[
                        getResponsiveStyle(
                          'TopnavMobileIPLOCATIONdettopnavmob',
                          measure
                        )
                      ],
                    ]}
                  >
                    <View>
                      <Text
                        style={[
                          styles.TopnavMobileIPText,
                          styles[
                            getResponsiveStyle('TopnavMobileIPText', measure)
                          ],
                        ]}
                      >
                        IP: {this.state.userIp}
                      </Text>
                    </View>
                    <View style={{ marginTop: 5 }}>
                      <Text
                        style={[
                          styles.TopnavMobileIPText,
                          styles[
                            getResponsiveStyle('TopnavMobileIPText', measure)
                          ],
                        ]}
                      >
                        Location: {this.state.userAddress}
                      </Text>
                    </View>
                  </View>
                )
              ) : null}
            </View>
            {this.state.dropdownOpen ? (
              this.state.hidemenu ? (
                <View
                  style={[
                    styles.TopnavMobileIPLOCATIONdettopnavmob,
                    styles[
                      getResponsiveStyle(
                        'TopnavMobileIPLOCATIONdettopnavmob',
                        measure
                      )
                    ],
                  ]}
                >
                  <View>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[
                          getResponsiveStyle('TopnavMobileIPText', measure)
                        ],
                      ]}
                    >
                      IP: {this.state.userIp}
                    </Text>
                  </View>
                  <View style={{ marginTop: 5 }}>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[
                          getResponsiveStyle('TopnavMobileIPText', measure)
                        ],
                      ]}
                    >
                      Location: {this.state.userAddress}
                    </Text>
                  </View>
                </View>
              ) : showip ? (
                <View
                  style={[
                    styles.TopnavMobileIPLOCATIONdettopnavmob,
                    styles[
                      getResponsiveStyle(
                        'TopnavMobileIPLOCATIONdettopnavmob',
                        measure
                      )
                    ],
                  ]}
                >
                  <View>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[
                          getResponsiveStyle('TopnavMobileIPText', measure)
                        ],
                      ]}
                    >
                      IP: {this.state.userIp}
                    </Text>
                  </View>
                  <View style={{ marginTop: 5 }}>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[
                          getResponsiveStyle('TopnavMobileIPText', measure)
                        ],
                      ]}
                    >
                      Location: {this.state.userAddress}
                    </Text>
                  </View>
                </View>
              ) : (
                <View
                  style={[
                    styles.TopnavMobileIPLOCATIONdettopnavmob,
                    styles[
                      getResponsiveStyle(
                        'TopnavMobileIPLOCATIONdettopnavmob',
                        measure
                      )
                    ],
                  ]}
                >
                  <View
                    style={[
                      styles.newTopNavImage2MainviewLocation,
                      // {
                      //   marginLeft: props.Dontshow_Searchoption ? props.Dontshow_Searchoption ? '55%' : null : null
                      // },
                      styles[
                        getResponsiveStyle(
                          'newTopNavImage2MainviewLocation',
                          measure
                        )
                      ],
                    ]}
                  >
                    <View style={{ marginTop: 5 }}>
                      <Text
                        style={[
                          styles.TopnavMobileIPText,
                          styles[
                            getResponsiveStyle('TopnavMobileIPText', measure)
                          ],
                        ]}
                      >
                        Location: {this.state.userAddress}
                      </Text>
                    </View>
                  </View>
                </View>
              )
            ) : null}
          </View>
          {/* {props.openMobilelist === true ? ( */}
          {Platform.OS !== 'web' ? (
            <Modal
              style={[
                styles.TopnavMobilemenuOpenDarkView,
                // { zIndex: 99999 },
                styles[
                  getResponsiveStyle('TopnavMobilemenuOpenDarkView', measure)
                ],
              ]}
              visible={props.openMobilelist}
              transparent
            >
              <View
                style={[
                  styles.TopnavMainview2,
                  styles[getResponsiveStyle('TopnavMainview2', measure)],
                ]}
              >
                <View
                  style={[
                    styles.TopnavMainview3,
                    styles[getResponsiveStyle('TopnavMainview3', measure)],
                  ]}
                >
                  <TouchableOpacity
                    onPress={() => {
                      props.RendermenuBar(!props.openMobilelist);
                    }}
                  >
                    <Image
                      style={[
                        styles.TopnavMobileMenuicon,
                        styles[
                          getResponsiveStyle('TopnavMobileMenuicon', measure)
                        ],
                      ]}
                      resizeMode="contain"
                      source={require('../../assets/images/menu.png')}
                    />
                  </TouchableOpacity>
                </View>
                <View
                  style={[
                    styles.TopnavMobileLogoView,
                    styles[getResponsiveStyle('TopnavMobileLogoView', measure)],
                  ]}
                >
                  <TouchableOpacity>
                    <Image
                      style={[
                        styles.TopnavMobileLogostyle,
                        styles[
                          getResponsiveStyle('TopnavMobileLogostyle', measure)
                        ],
                      ]}
                      resizeMode="contain"
                      source={require('../../assets/images/icici-bank-logo.svg')}
                    />
                  </TouchableOpacity>
                </View>
              </View>

              <View
                style={[
                  styles.TopnavMobilemenuOpenMainView,
                  styles[
                    getResponsiveStyle('TopnavMobilemenuOpenMainView', measure)
                  ],
                ]}
              >
                <View
                  style={[
                    styles.TopnavMobilemenuOpenMainView2,
                    styles[
                      getResponsiveStyle(
                        'TopnavMobilemenuOpenMainView2',
                        measure
                      )
                    ],
                  ]}
                >
                  <TouchableOpacity
                    onPress={() => {
                      props.RendermenuBar(!props.openMobilelist);
                    }}
                  >
                    <Image
                      style={[
                        styles.TopnavMobileMenuicon,
                        styles[
                          getResponsiveStyle('TopnavMobileMenuicon', measure)
                        ],
                      ]}
                      resizeMode="contain"
                      source={require('../../assets/images/menu.png')}
                    />
                  </TouchableOpacity>
                </View>
                {/* <View
                style={[
                  styles.TopnavMobilemenulogoView,
                  styles[
                    getResponsiveStyle('TopnavMobilemenulogoView', measure)
                  ]
                ]}
              >
                <TouchableOpacity>
                  <Image
                    style={[
                      styles.TopnavMobilemenulogostyle,
                      styles[
                        getResponsiveStyle('TopnavMobilemenulogostyle', measure)
                      ]
                    ]}
                    resizeMode='contain'
                    source={require('../../assets/images/icici_bank_logo_symbol.png')}
                  />
                </TouchableOpacity>
              </View> */}
                {Platform.OS === 'web' ? (
                  <View
                    style={[
                      styles.TopnavMobileIPLOCATIONdet,
                      styles[
                        getResponsiveStyle('TopnavMobileIPLOCATIONdet', measure)
                      ],
                    ]}
                  >
                    <View>
                      <Text
                        style={[
                          styles.TopnavMobileIPText,
                          styles[
                            getResponsiveStyle('TopnavMobileIPText', measure)
                          ],
                        ]}
                      >
                        IP: {this.state.userIp}
                      </Text>
                    </View>
                    <View style={{ marginTop: 5 }}>
                      <Text
                        style={[
                          styles.TopnavMobileIPText,
                          styles[
                            getResponsiveStyle('TopnavMobileIPText', measure)
                          ],
                        ]}
                      >
                        Location: {this.state.userAddress}
                      </Text>
                    </View>
                  </View>
                ) : null}
                <View
                  style={[
                    styles.TopnavMobilemenuUNderlineView,
                    styles[
                      getResponsiveStyle(
                        'TopnavMobilemenuUNderlineView',
                        measure
                      )
                    ],
                  ]}
                >
                  <View
                    style={[
                      styles.TopnavMobilemenuUNderlinestyle,
                      styles[
                        getResponsiveStyle(
                          'TopnavMobilemenuUNderlinestyle',
                          measure
                        )
                      ],
                    ]}
                  />
                </View>
                <View style={{ backgroundColor: '#e9e9e9', height: 1200 }}>
                  {props.ServiceRequests.map((item, index) => {
                    if (item.serviceSelected) {
                      return (
                        <View
                          style={[
                            styles.TopnavMobilemenureqMinView,
                            styles[
                              getResponsiveStyle(
                                'TopnavMobilemenureqMinView',
                                measure
                              )
                            ],
                          ]}
                        >
                          <View
                            style={[
                              styles.TopnavMobilemenureqMinView2,
                              styles[
                                getResponsiveStyle(
                                  'TopnavMobilemenureqMinView2',
                                  measure
                                )
                              ],
                            ]}
                          >
                            <TouchableOpacity
                              onPress={() => {
                                props.OnServiceRequestsButtonPress(
                                  item.servicename,
                                  item.menuType,
                                  index,
                                  item.menuHeader,
                                  item.menuname
                                );
                              }}
                              style={[
                                styles.TopnavMobilemenureqMinbtn1style,
                                {
                                  height:
                                    (this.state.windowHeight - 120) /
                                    props.ServiceRequests.length,
                                },
                                styles[
                                  getResponsiveStyle(
                                    'TopnavMobilemenureqMinbtn1style',
                                    measure
                                  )
                                ],
                              ]}
                            >
                              <View
                                style={[
                                  styles.TopnavMobilemenureqMinbtn1PaddingView,
                                  styles[
                                    getResponsiveStyle(
                                      'TopnavMobilemenureqMinbtn1PaddingView',
                                      measure
                                    )
                                  ],
                                ]}
                              >
                                <Image
                                  style={[
                                    styles.TopnavMobilemenureqMinimage1style,
                                    styles[
                                      getResponsiveStyle(
                                        'TopnavMobilemenureqMinimage1style',
                                        measure
                                      )
                                    ],
                                  ]}
                                  resizeMode="contain"
                                  source={{ uri: item.imageIcons }}
                                />
                              </View>
                              <View
                                style={[
                                  styles.TopnavMobilemenureqMinTextViewstyle,
                                  styles[
                                    getResponsiveStyle(
                                      'TopnavMobilemenureqMinTextViewstyle',
                                      measure
                                    )
                                  ],
                                ]}
                              >
                                <Text
                                  style={[
                                    styles.TopnavMobilemenureqMinText1style,
                                    styles[
                                      getResponsiveStyle(
                                        'TopnavMobilemenureqMinText1style',
                                        measure
                                      )
                                    ],
                                  ]}
                                >
                                  {item.servicename}
                                </Text>
                              </View>
                            </TouchableOpacity>
                          </View>
                        </View>
                      );
                    } else {
                      return (
                        <View
                          style={[
                            styles.TopnavMobilemenureqMinView,
                            styles[
                              getResponsiveStyle(
                                'TopnavMobilemenureqMinView',
                                measure
                              )
                            ],
                          ]}
                        >
                          <View
                            style={[
                              styles.TopnavMobilemenureqMinView3,
                              styles[
                                getResponsiveStyle(
                                  'TopnavMobilemenureqMinView3',
                                  measure
                                )
                              ],
                            ]}
                          >
                            <TouchableOpacity
                              onPress={() => {
                                props.OnServiceRequestsButtonPress(
                                  item.servicename,
                                  item.menuType,
                                  index,
                                  item.menuHeader,
                                  item.menuname
                                );
                              }}
                              style={[
                                styles.TopnavMobilemenureqMinbtn1style,
                                {
                                  height:
                                    (this.state.windowHeight - 120) /
                                    props.ServiceRequests.length,
                                },
                                styles[
                                  getResponsiveStyle(
                                    'TopnavMobilemenureqMinbtn1style',
                                    measure
                                  )
                                ],
                              ]}
                            >
                              <View
                                style={[
                                  styles.TopnavMobilemenureqMinbtn1PaddingView,
                                  styles[
                                    getResponsiveStyle(
                                      'TopnavMobilemenureqMinbtn1PaddingView',
                                      measure
                                    )
                                  ],
                                ]}
                              >
                                <Image
                                  style={[
                                    styles.TopnavMobilemenureqMinimage1style,
                                    styles[
                                      getResponsiveStyle(
                                        'TopnavMobilemenureqMinimage1style',
                                        measure
                                      )
                                    ],
                                  ]}
                                  resizeMode="contain"
                                  source={{ uri: item.imageIcons }}
                                />
                              </View>
                              <View
                                style={[
                                  styles.TopnavMobilemenureqMinTextViewstyle,
                                  styles[
                                    getResponsiveStyle(
                                      'TopnavMobilemenureqMinTextViewstyle',
                                      measure
                                    )
                                  ],
                                ]}
                              >
                                <Text
                                  style={[
                                    styles.TopnavMobilemenureqMinText2style,
                                    styles[
                                      getResponsiveStyle(
                                        'TopnavMobilemenureqMinText2style',
                                        measure
                                      )
                                    ],
                                  ]}
                                >
                                  {item.servicename}
                                </Text>
                              </View>
                            </TouchableOpacity>
                          </View>
                        </View>
                      );
                    }
                  })}
                </View>
              </View>
            </Modal>
          ) : (
            [
              props.openMobilelist ? (
                <View
                  style={[
                    styles.TopnavMobilemenuOpenDarkView,
                    { zIndex: 99999 },
                    styles[
                      getResponsiveStyle(
                        'TopnavMobilemenuOpenDarkView',
                        measure
                      )
                    ],
                  ]}
                  // visible={props.openMobilelist}
                  // transparent
                >
                  <View
                    style={[
                      styles.TopnavMobilemenuOpenMainView,
                      styles[
                        getResponsiveStyle(
                          'TopnavMobilemenuOpenMainView',
                          measure
                        )
                      ],
                    ]}
                  >
                    <View
                      style={[
                        styles.TopnavMobilemenuOpenMainView2,
                        styles[
                          getResponsiveStyle(
                            'TopnavMobilemenuOpenMainView2',
                            measure
                          )
                        ],
                      ]}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          props.RendermenuBar(!props.openMobilelist);
                        }}
                      >
                        <Image
                          style={[
                            styles.TopnavMobileCloseicon,
                            styles[
                              getResponsiveStyle(
                                'TopnavMobileCloseicon',
                                measure
                              )
                            ],
                          ]}
                          resizeMode="contain"
                          source={require('../../assets/images/closeMenu.png')}
                        />
                      </TouchableOpacity>
                    </View>
                    {/* <View
                    style={[
                      styles.TopnavMobilemenulogoView,
                      styles[
                        getResponsiveStyle('TopnavMobilemenulogoView', measure)
                      ]
                    ]}
                  >
                    <TouchableOpacity>
                      <Image
                        style={[
                          styles.TopnavMobilemenulogostyle,
                          styles[
                            getResponsiveStyle(
                              'TopnavMobilemenulogostyle',
                              measure
                            )
                          ]
                        ]}
                        resizeMode='contain'
                        source={require('../../assets/images/icici_bank_logo_symbol.png')}
                      />
                    </TouchableOpacity>
                  </View> */}
                    {Platform.OS === 'web' ? (
                      <View
                        style={[
                          styles.TopnavMobileIPLOCATIONdettopnavmob,
                          styles[
                            getResponsiveStyle(
                              'TopnavMobileIPLOCATIONdettopnavmob',
                              measure
                            )
                          ],
                        ]}
                      >
                        <View>
                          <Text
                            style={[
                              styles.TopnavMobileIPText,
                              styles[
                                getResponsiveStyle(
                                  'TopnavMobileIPText',
                                  measure
                                )
                              ],
                            ]}
                          >
                            IP: {this.state.userIp}
                          </Text>
                        </View>
                        <View style={{ marginTop: 5 }}>
                          <Text
                            style={[
                              styles.TopnavMobileIPText,
                              styles[
                                getResponsiveStyle(
                                  'TopnavMobileIPText',
                                  measure
                                )
                              ],
                            ]}
                          >
                            Location: {this.state.userAddress}
                          </Text>
                        </View>
                      </View>
                    ) : null}
                    <View
                      style={[
                        styles.TopnavMobilemenuUNderlineView,
                        styles[
                          getResponsiveStyle(
                            'TopnavMobilemenuUNderlineView',
                            measure
                          )
                        ],
                      ]}
                    >
                      <View
                        style={[
                          styles.TopnavMobilemenuUNderlinestyle,
                          styles[
                            getResponsiveStyle(
                              'TopnavMobilemenuUNderlinestyle',
                              measure
                            )
                          ],
                        ]}
                      />
                    </View>
                    <View
                      style={{
                        backgroundColor: '#fffff',
                        height: this.props.overdueFlag ? 500 : '100vh',
                      }}
                    >
                      <FlatList
                        data={formatData(props.ServiceRequests, 2)}
                        renderItem={this.renderItem}
                        numColumns={this.props.overdueFlag ? 1 : 2}
                        extraData={this.state}
                      />
                      {this.props.overdueFlag ? (
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <View
                            style={[
                              style.menuNameView,
                              {
                                backgroundColor: 'white',
                              },
                            ]}
                          >
                            <TouchableOpacity
                              onPress={() => {
                                this.logout();
                              }}
                            >
                              <View
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                }}
                              >
                                <View>
                                  <Image
                                    style={[style.verificationImage]}
                                    source={require(`../OverDue/components/icons/logout.svg`)}
                                  ></Image>
                                </View>
                                <View
                                  style={{
                                    marginLeft: 10,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <Text
                                    style={[
                                      style.menuName,
                                      {
                                        fontFamily: "'Mulish'",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '20px',
                                        lineHeight: '12px',
                                        color: '#787F89',
                                        color: '#787F89',
                                      },
                                    ]}
                                  >
                                    Logout
                                  </Text>
                                </View>
                              </View>
                            </TouchableOpacity>
                          </View>
                        </View>
                      ) : null}
                    </View>
                  </View>
                </View>
              ) : null,
            ]
          )}
        </View>
        {homeScreen ? null : (
          <View
            style={[
              styles.newTopNavbar,
              {
                backgroundImage: 'linear-gradient(to bottom, #f58e21, #ef6812)',
              },
              styles[getResponsiveStyle('newTopNavbar', measure)],
            ]}
          ></View>
        )}
      </View>
    );
  }
}

Topsection.propTypes = {
  Dontshow_Searchoption: PropTypes.any,
  OnServiceRequestsButtonPress: PropTypes.func,
  TopnavMobcallback: PropTypes.func,
  homeScreen: PropTypes.any,
  makeAPICall: PropTypes.any,
  measure: PropTypes.string,
  navigation: PropTypes.shape({
    navigate: PropTypes.func,
    state: PropTypes.shape({
      params: PropTypes.shape({
        flag: PropTypes.any,
        flow: PropTypes.any,
        menuType: PropTypes.any,
        menuname: PropTypes.any,
        serviceDynamic: PropTypes.any,
        serviceMessageForNoDynamic: PropTypes.any,
        serviceType: PropTypes.any,
        servicename: PropTypes.any
      })
    })
  }),
  overdueFlag: PropTypes.any,
  selectedIndex: PropTypes.any,
  verification: PropTypes.any
}
